<template>
<div>
    <div class="row justify-content-center" v-if="componentState === 'index'">
        <!-- index interface -->
        <div class="col-sm-12 col-md-6">
            <div class="card">
                <div class="card-body">
                    <a-form :form="form">
                    <div class="row">
                        <div class="col-lg-6">
                            <a-form-item label="Select Report Type" class="col-12">
                                <a-select default-value="1" @change="handleReportType">
                                    <a-select-option value="1">Daily Report</a-select-option>
                                    <a-select-option value="2">Monthly Report</a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div class="col-lg-6">
                            <a-form-item label="Select Date" class="col-12">
                                <!-- <a-range-picker @change="onChange"></a-range-picker> -->
                                <a-date-picker v-model="date" v-show="ifdaily"></a-date-picker>
                                <a-month-picker v-model="date" v-show="!ifdaily"></a-month-picker>
                            </a-form-item>
                        </div>

                        <a-divider style="margin:15px 0px 5px 0px;"/>
                        <div class="col" style="text-align: right; padding:15px 0px;">
                            <div class="col">
                                <div class="col">
                                    <a-button type="primary" @click="handleReport" :disabled="btnState.viewFrozen">View Report</a-button>&nbsp;
                                    <a-button icon="download" @click="handleDownload" :disabled="disablebtn">Download Report</a-button>&nbsp;
                                    <a-button v-if="schoolId === 23 && !ifdaily" icon="printer" type="dashed" :disabled="disablebtn" @click="handlePrint">
                                      Print Format
                                    </a-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    </a-form>
                </div>
            </div>
        </div>
        <!-- end index interface -->
    </div>
</div>

</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
// import dailyReport from '@/components/StaffAttendance/dailyreport'

export default {
  name: 'AttendanceIndex',
  //   components: { dailyReport },
  computed: {
    ...mapState({
      schoolId: state => state.user.user.school.id,
    }),
  },
  data: function() {
    return {
      form: this.$form.createForm(this, { name: 'attendanceindex' }),
      date: moment(),
      disablebtn: false,
      bodydata: {
        url: '/api/staff/attendance/report/daily/export',
        reporttype: 'daily',
      },
      componentState: 'index',
      ifdaily: true,
      btnState: { viewFrozen: true, downloadFrozen: true },
    }
  },
  watch: {
    date: function(n, o) {
      console.log('this.date', n)
      if (n === null) {
        this.btnState.viewFrozen = true
      } else {
        this.btnState.viewFrozen = false
      }
    },
  },
  methods: {
    moment,
    // handleDate: function(d, ds) {
    //   if (d === null) {
    //     this.btnState.viewFrozen = true
    //     return
    //   }
    //   this.date = [ ds, ds ]
    //   this.btnState.viewFrozen = false
    // },
    // handleMonth: function(d, ds) {
    //   if (d === null) {
    //     this.btnState.viewFrozen = true
    //     return
    //   }
    //   let firstday = d.startOf('month').format('YYYY-MM')
    //   let lastday = d.endOf('month').format('YYYY-MM-DD')
    //   this.date = [ firstday, lastday ]
    //   this.btnState.viewFrozen = false
    // },
    handleReport: function() {
      // this.componentState = 'dailyreport'
      if (this.bodydata.reporttype === 'daily') {
        console.log(moment(this.date).format('YYYY-MM-DD'))
        this.$router.push({ name: 'dailyattendancereport', params: { day: moment(this.date).format('YYYY-MM-DD') } })
      } else {
        console.log(moment(this.data).format('YYYY-MM'))
        this.$router.push({ name: 'monthlyattendancereport', params: { month: moment(this.date).format('YYYY-MM') } })
      }
      // this.$router.push({ name: 'monthlyattendancereport', params: { month: '07' }})
    },
    handleReportType: function(value) {
      console.log('change', value)
      this.ifdaily = !this.ifdaily
      this.date = moment()
      console.log('ifdaily', this.ifdaily)
      if (value === 1) {
        this.bodydata = {
          url: '/api/staff/attendance/report/daily/export',
          reporttype: 'daily',
        }
      } else {
        this.bodydata = {
          url: '/api/staff/attendance/report/monthly/export',
          reporttype: 'monthly',
        }
      }
      // change url and prepare readydata
    },
    onChange: function(date, datestring) {
      // console.log(datestring)
      this.date = datestring
      console.log(this.date)
    },
    handleDownload: function () {
      this.disablebtn = true
      if (this.date != null) {
        var readydata = {}
        var filename = ''
        if (this.bodydata.reporttype === 'daily') {
          readydata = { start_date: moment(this.date).format('YYYY-MM-DD'), end_date: moment(this.date).format('YYYY-MM-DD') }
          filename = 'daily_attendance_'
        } else {
          readydata = { start_date: moment(this.date).startOf('month').format('YYYY-MM-DD'), end_date: moment(this.date).endOf('month').format('YYYY-MM-DD') }
          filename = 'monthly_attendance_'
        }
        const header = { headers: { 'Content-Type': 'application/jsons', Accept: 'application/json' },
          responseType: 'blob' }

        console.log('bodydata', this.bodydata)
        console.log('readydata', readydata)
        console.log('filename', filename)

        this.$http.post(this.bodydata.url, readydata, header)
          .then((res) => {
            var FILE = window.URL.createObjectURL(new Blob([res.data])) // new Blob([res.data], { type: 'application/json' }) // window.URL.createObjectURL(new Blob([res.data]))
            var docURL = document.createElement('a')
            docURL.href = FILE
            docURL.setAttribute('download', `${filename}${this.moment(this.date).format('YYYY-MM-DD')}.xlsx`)
            document.body.appendChild(docURL)
            docURL.click()
            this.disablebtn = false
          })
          .catch((err) => {
            console.log(err)
            this.disablebtn = false
          })
      }
    },
    handlePrint() {
      this.disablebtn = true
      if (this.date) {
        const readydata = {
          start_date: this.moment(this.date).startOf('month').format('YYYY-MM-DD'),
          end_date: this.moment(this.date).endOf('month').format('YYYY-MM-DD'),
        }

        const filename = `monthly_attendance_${this.moment(this.date).format('YYYY-MM')}.xlsx`

        this.$http.post(
          'api/staff/attendance/report/monthly/comet/export',
          readydata,
          {
            responseType: 'blob', // must be outside headers
            headers: {
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
          }
        )
          .then((res) => {
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link.remove()
            this.disablebtn = false
          })
          .catch((err) => {
            console.error(err)
            this.disablebtn = false
          })
      }
    },

    // handlePrint() {
    //   this.disablebtn = true
    //   if (this.date) {
    //     const readydata = {
    //       start_date: this.moment(this.date).startOf('month').format('YYYY-MM-DD'),
    //       end_date: this.moment(this.date).endOf('month').format('YYYY-MM-DD'),
    //     }

    //     const header = {
    //       headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    //       responseType: 'blob',
    //     }

    //     const filename = 'monthly_attendance_'
    //     this.$http.post('api/staff/attendance/report/monthly/comet/export', readydata, header)
    //       .then(res => {
    //         // const FILE = window.URL.createObjectURL(new Blob([res.data]))
    //         const FILE = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
    //         const docURL = document.createElement('a')
    //         docURL.href = FILE
    //         docURL.setAttribute(
    //           'download',
    //           `${filename}${this.moment(this.date).format('YYYY-MM')}.xlsx`
    //         )
    //         document.body.appendChild(docURL)
    //         docURL.click()
    //         this.disablebtn = false
    //       })
    //       .catch(err => {
    //         console.error(err)
    //         this.disablebtn = false
    //       })
    //   }
    // },

  },
}
</script>

<style>

</style>
